import "./style/editorial-content.scss"

import React from "react"
import classNames from "classnames"

// Icons
import arrowExternalIcon from "@ng-mw/reol/icons/arrowExternal"

// Components
import Icon from "@ng-mw/reol/components/Icon"
import { AppSafeLink } from "@ng-mw/shared-react-components/shared"

export type LinkBehavior = "open" | "prevent-navigation"

interface InspirationContentBlockProps {
    id: string
    content: any
    linkBehavior?: LinkBehavior
    onClick?: () => void
}

const ContentBlock = ({
    id,
    content,
    linkBehavior = "open",
    onClick,
}: InspirationContentBlockProps) => {
    const shouldPreventNavigation = linkBehavior === "prevent-navigation"

    const renderedContent = (
        <>
            {content.Image ? (
                <img
                    className="editorial-content__image"
                    src={content.Image}
                    alt={content.Title}
                    width="400px"
                    height="110px"
                />
            ) : null}
            <div className="editorial-content__content">
                <h3 className="editorial-content__title">{content.Title}</h3>
                {content.Link ? (
                    <span className="editorial-content__link">
                        <Icon
                            icon={arrowExternalIcon}
                            isInline
                        />
                    </span>
                ) : null}
            </div>
        </>
    )

    if (content.Link) {
        return (
            <AppSafeLink
                id={id}
                appHref={shouldPreventNavigation ? undefined : content.Link}
                onClickApp={onClick}
                className={classNames(
                    "editorial-content__item",
                    `editorial-content__item--style-${content.Style}`,
                )}
                usePlainElement
            >
                {renderedContent}
            </AppSafeLink>
        )
    }

    return (
        <div
            className={classNames(
                "editorial-content__item",
                `editorial-content__item--style-${content.Style}`,
            )}
            id={id}
        >
            {renderedContent}
        </div>
    )
}

export default ContentBlock
